import { render, staticRenderFns } from "./mediatype.vue?vue&type=template&id=3a9ceed4&scoped=true"
import script from "./mediatype.vue?vue&type=script&lang=js"
export * from "./mediatype.vue?vue&type=script&lang=js"
import style0 from "./mediatype.vue?vue&type=style&index=0&id=3a9ceed4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9ceed4",
  null
  
)

export default component.exports